import { Pipe, PipeTransform } from '@angular/core';
import { CATALOG } from '@core';

@Pipe({name: 'changeRMPipe'})
export class ChangeRMPipe implements PipeTransform {
  transform(rm: {code:string, name: string}): string {
    let txt =  "";
    // if (CATALOG.getListRm && CATALOG.getListRm.length > 0) {
      
    //   const tmpItem = CATALOG.getListRm.find(f => f.key && f.key === rm.code);
     
    //   if (tmpItem && tmpItem.value) {
    //     txt = tmpItem.value;
    //   } else {
    //     if(rm.code || rm.name) {
    //       txt = `${rm.code} - ${rm.name}`;
    //     }
         
    //   }
    // } else {
    //   txt = `${rm.code} - ${rm.name}`;
    // }
    return txt;
  }
}
